import { ReactComponent as WhiteCloseIcon } from '@/assets/images/svg/glyphs/close-white.svg';


type CloseBtnProps = {
  onClick: () => void;
  className?: string;
}

export const CloseBtn = ({ onClick, className }: CloseBtnProps) => {

  return (
    <button
      onClick={onClick}
      aria-label="Dismiss banner"
      className={className}
    >
      <WhiteCloseIcon className="w-2 h-2" />
    </button>
  )
}
